export default function checkIsTicketMachine() {
    const urlId = window.location.hash.substring(1);
    const params = new URLSearchParams(window.location.search);
    return urlId.length <= 7 && params.get("debugMode")!="true";
}